import { deleteSegment } from '@gonfalon/openapi/operations/deleteSegment';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { segments } from '../queries/segments';

export const useDeleteSegment = createMutationHook(deleteSegment, {
  onSuccess: async () => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: segments.list._def });
  },
});
